import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';

const features = [
  { icon: 'FiTarget', title: 'Marketing Strategy', desc: 'Clear direction built around measurable goals.' },
  { icon: 'FiCode', title: 'Web & Software', desc: 'Modern technology designed around your operations.' },
  { icon: 'FiTrendingUp', title: 'Lead Generation', desc: 'SEO, ads, social, and email working together.' },
  { icon: 'FiCpu', title: 'AI & Automation', desc: 'Practical systems that capture more opportunities.' }
];

const TrustBar = () => {
  return (
    <section className="relative z-20 -mt-20">
      <div className="container-custom">
        <motion.div 
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="glass-panel rounded-3xl p-8 md:p-12 relative overflow-hidden"
        >
          <div className="absolute top-0 left-0 w-full h-[1px] bg-gradient-to-r from-transparent via-cyan-500 to-transparent opacity-50"></div>
          
          <div className="text-center mb-12">
            <h2 className="text-2xl font-display font-medium text-gray-200">
              Three Founders. More Than a Decade of Collaboration. <span className="text-cyan-400">One Unified Team.</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative z-10">
            {features.map((feature, idx) => (
              <div key={idx} className="flex flex-col items-center text-center group">
                <div className="w-16 h-16 rounded-2xl bg-gray-900 border border-gray-800 flex items-center justify-center mb-6 group-hover:border-cyan-500/50 group-hover:shadow-[0_0_20px_rgba(6,182,212,0.2)] transition-all duration-300">
                  <SafeIcon icon={feature.icon} className="text-3xl text-cyan-400" />
                </div>
                <h3 className="font-display font-bold text-lg text-white mb-3">{feature.title}</h3>
                <p className="text-gray-400 text-base leading-relaxed">{feature.desc}</p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default TrustBar;